import { render, staticRenderFns } from "./CoverFilterSummary.vue?vue&type=template&id=be8e5daa"
import script from "./CoverFilterSummary.vue?vue&type=script&lang=js"
export * from "./CoverFilterSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports